import { Component, Input } from '@angular/core';
import { TcmBaseForm } from '../../../../modules/tcm-common/base/tcm-base-form';
import { SecureBaseComponentContext } from '../../../../modules/tcm-common/services/secure-base-component-context.service';
import { SendSmsInfo } from './send-sms-info';
import { PatientSmsTemplateOption } from '../../../../models/patients';
import { SmsTemplateDataService } from '../../../../services/sms-template-data.service';

@Component({
    selector: 'send-sms',
    templateUrl: './send-sms.component.html',
    standalone: false
})
export class SendSmsComponent extends TcmBaseForm {

  @Input()
  clinicId: number;

  @Input()
  patientId: number;

  @Input()
  smsTemplates: PatientSmsTemplateOption[];

  smsTemplateId: number;
  smsText: string;

  getSmsTemplateOptionsFunc = (query: string, cancellationToken: Promise<any>): Promise<PatientSmsTemplateOption[]> => {
    return this.smsTemplateDataService.getSmsTemplateOptionsAsync(query, this.clinicId, this.patientId, cancellationToken);
  }

  constructor(protected componentContext: SecureBaseComponentContext,
    private smsTemplateDataService: SmsTemplateDataService) {
    super();
  }

  onSmsTemplateChanged(selectedOption: any) {
    if (selectedOption) {
      this.smsText = selectedOption.message;
    } else {
      this.smsText = '';
    }
  }

  sendSms() {
    this.processSave(() => {
      this.componentContext.navService.navigateBack({
        smsTemplateId: this.smsTemplateId,
        smsText: this.smsText
      } as SendSmsInfo);
    });
  }

  back() {
    this.componentContext.navService.navigateBack();
  }
}